// ────────────────────────────
// src/components/WebAppSection.jsx
// ────────────────────────────
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "animate.css";                  // WOW + animate.css

import "./WebAppSection.css";

// ──────────── IMÁGENES DEL DASHBOARD ────────────
import shotClientsList         from "../assets/images/dashboard-screenshots/dashboard-clients.png";
import shotClientsInvite       from "../assets/images/dashboard-screenshots/dashboard-clients-invite.png";
import shotRoutinesOverview    from "../assets/images/dashboard-screenshots/dashboard-routines.png";
import shotRoutinesExercise    from "../assets/images/dashboard-screenshots/dashboard-routines-modify-exercise.png";
import shotRoutinesEditRoutine from "../assets/images/dashboard-screenshots/dashboard-routines-modify-routine.png";
import shotRoutinesCopyDay     from "../assets/images/dashboard-screenshots/dashboard-routines-copy-day.png";
import shotRoutinesCopyWeek    from "../assets/images/dashboard-screenshots/dashboard-routines-copy-week.png";
import shotDietsOptions           from "../assets/images/dashboard-screenshots/dashboard-diets-options.png";
// import shotDietsWeekly           from "../assets/images/dashboard-screenshots/dashboard-diets-weekly.png";
import shotProgressTop       from "../assets/images/dashboard-screenshots/dashboard-progress-top.png";
// import shotProgressBottom      from "../assets/images/dashboard-screenshots/dashboard-progress-bottom.png";

// ──────────── ARRAY DE SLIDES ────────────
const slides = [
  shotClientsList,
  shotClientsInvite,
  shotRoutinesOverview,
  shotRoutinesExercise,
  shotRoutinesEditRoutine,
  shotRoutinesCopyDay,
  shotRoutinesCopyWeek,
  shotDietsOptions,
  // shotDietsWeekly,
  shotProgressTop,
  // shotProgressBottom,
];

const slideAlts = [
  "Listado de clientes – aplicación para entrenadores personales Zasfit",
  "Invitar cliente por correo – app de entrenamiento personal Zasfit",
  "Vista general de rutinas semanales – aplicación de entrenamiento Zasfit",
  "Editar ejercicio dentro de rutina – software para entrenadores Zasfit",
  "Configurar rutina personalizada – app para entrenadores personales Zasfit",
  "Copiar día de rutina entre semanas – aplicación Zasfit",
  "Copiar semana completa de rutina – software de entrenamiento Zasfit",
  "Opciones de dieta por comidas – aplicación de nutrición Zasfit",
  "Plan semanal de dieta – app para entrenadores Zasfit",
  "Gráfico de progreso de peso y macros – aplicación Zasfit",
  "Historial de progreso y métricas – app de entrenamiento personal Zasfit"
];


export default function WebAppSection() {
  const isMobile = window.matchMedia('(max-width: 991.98px)').matches;

  const swiperProps = isMobile
  ? {
      // allowTouchMove: false,
      // touchStartPreventDefault: false,
      grabCursor: false,
    }
  : {
      // allowTouchMove: true,
      grabCursor: true,
    };

  return (
    <section id="webapp" className="web-app-section pt-0 pb-50 z-1">
      <div className="webapp-container">
        <div className="hero-bg" />

        {/* ─────────── TÍTULO ─────────── */}
        <header className="webapp-title text-center">
          <h2
            className="webapp-eyebrow eyebrow-label wow animate__animated animate__fadeInUp"
            data-wow-delay="0.05s"
            data-wow-duration="1s"
          >
            Dashboard para Entrenadores
          </h2>

          <h3
            className="section-hook hero-title wow animate__animated animate__fadeInUp"
            data-wow-delay="0.10s"
            data-wow-duration="1s"
          >
            <span>El Portal Online<br/>para<span className="gradient-text"> optimizar tu trabajo</span></span>
          </h3>

          <p
            className="desc wow animate__animated animate__fadeInUp"
            data-wow-delay="0.2s"
            data-wow-duration="1s"
          >
            Todas las herramientas
            que necesitas para tu día a día como entrenador personal
            en un único lugar.
          </p>
        </header>

        {/* ─────────── FEATURES ─────────── */}
        <ul className="wa-feature-row">
          {[
            { cls: "cli", glyph: "group",      title: "Clientes", desc: "Fichas, notas y progreso." },
            { cls: "rut", glyph: "exercise",   title: "Rutinas",  desc: "Crea y programa entrenos." },
            { cls: "die", glyph: "restaurant", title: "Dietas",   desc: "Planifica menús y macros." },
            { cls: "pro", glyph: "finance",    title: "Progreso", desc: "Analiza métricas clave." },
          ].map(({ cls, glyph, title }, i) => (
            <li
              key={title}
              className={`
                wa-card ${cls}
                wow animate__animated animate__fadeInUpShort
              `}
              data-wow-delay={`${0.2 + i * 0.1}s`}
              data-wow-duration="1s"
            >
              <span className="wa-icon">
                <span className="material-symbols-outlined wa-glyph">{glyph}</span>
              </span>
              <h3 className="wa-card-title">{title}</h3>
            </li>
          ))}
        </ul>

        {/* ─────────── SWIPER ─────────── */}
        <Swiper
          modules={[Autoplay, Navigation]}
          loop
          centeredSlides
          slidesPerView="auto"
          spaceBetween={32}
          speed={700}
          navigation
          grabCursor={!isMobile}
          autoplay={{ delay: 4500, disableOnInteraction: true }}
          {...swiperProps}
          className="
            webapp-swiper swiper--noTouch
            wow animate__animated animate__fadeIn
          "
          data-wow-delay="0.35s"
          data-wow-duration="1.2s"
        >
          {slides.map((src, i) => (
            <SwiperSlide key={i}>
              <img src={src} alt={slideAlts[i]} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
